export class ApiError extends Error {
  constructor(message: string, readonly status: number) {
    super(message);
  }
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(path, {
    ...init,
    headers: { "Content-Type": "application/json", ...init?.headers },
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) throw new ApiError((body as any).error ?? res.statusText, res.status);
  return body as T;
}

export const api = {
  get: <T>(path: string) => request<T>(path),
  post: <T>(path: string, data?: unknown) =>
    request<T>(path, { method: "POST", body: JSON.stringify(data ?? {}) }),
  patch: <T>(path: string, data?: unknown) =>
    request<T>(path, { method: "PATCH", body: JSON.stringify(data ?? {}) }),
  del: <T>(path: string) => request<T>(path, { method: "DELETE" }),
};

export interface ItineraryEvent {
  id: string;
  slug: string;
  name: string;
  tagline: string | null;
  description: string | null;
  startsAt: string | null;
  endsAt: string | null;
  venueName: string | null;
  address: string | null;
  mapUrl: string | null;
  dressCode: string | null;
  rsvp: {
    attending: boolean;
    partySize: number;
    dietary: string | null;
    notes: string | null;
    respondedAt: string;
  } | null;
}

export interface Me {
  user: { id: string; email: string; name: string };
  isAdmin: boolean;
  needsOnboarding: boolean;
  guest: {
    id: string;
    fullName: string;
    email: string | null;
    phone: string | null;
    status: string;
    partyMax: number;
  } | null;
}
